import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { openingHourI } from 'app/core/interfaces/schedule';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import * as moment from 'moment';

@Component({
  selector: 'page-hours-form',
  templateUrl: './hours-form.component.html',
  styleUrls: ['./hours-form.component.scss']
})
export class HoursFormComponent extends BaseComponent implements OnInit {

  @Input() public hours: openingHourI[] = [];
  @Output() onUpdate = new EventEmitter<openingHourI[]>();

  ngOnInit(): void {


  }

  onChangeForm() {  
    this.onUpdate.emit(this.hours);
  }

  hasRightTime(horario: openingHourI) {
    if (!horario || horario.timeStart == '' || horario.timeEnd == '') {
      return true;
    }
    return moment(horario.timeStart, 'HH:mm') < moment(horario.timeEnd, 'HH:mm');
  }

  getDayOfWeekName(code: any) {
    return this.layout.getDayOfWeekName(code);
  }

  addDayOfWeekTime(dayOfWeek: number) {
    this.hours.push({
      dayOfWeek: dayOfWeek,
      timeStart: '',
      timeEnd: ''
    });
  }

  removeTime(key: number) {
    const count = this.hours.reduce((previous:any, current: any) => {
      if (current.dayOfWeek == this.hours[key].dayOfWeek) {
        previous += 1;
      }    
      return previous;
    }, 0);
    if (count > 1) {
      this.hours.splice(key, 1);
    }
    
  }

}
